function readURL(input) {
    if (input.files && input.files[0]) {
        var reader = new FileReader();

        reader.onload = function (e) {
            $('#uploaded-img').html('<img class="img-responsive padding-v-0-15" src="  ' + e.target.result + ' " />')
        }

        reader.readAsDataURL(input.files[0]);
    }
}

$("#file-upload-img").change(function(){
    readURL(this);
});


//Add New Avatar
function readURLAvatar(input) {
    if (input.files && input.files[0]) {
        var reader = new FileReader();

        reader.onload = function (e) {
            $('.form-avatar').html('<div class="inner-circle"><img class="avatar" src="  ' + e.target.result + ' " /></div>');
        }

        reader.readAsDataURL(input.files[0]);
    }
}

$('.upload-avatar-btn input').change(function(){
    $('.wrap-avatar').addClass('new-avatar');
    readURLAvatar(this);
    setTimeout(function(){
        $('.form-avatar img').each(function() {
            if ($(this).width() > $(this).height()) {
                $(this).addClass('landscape');
            }
        });
    }, 10);
});




// WEBPACK FOOTER //
// ./resources/assets/themes/default/js/file-upload-single.js